const init = () => {
    window.hj = window.hj || function() {
        (window.hj.q = window.hj.q || []).push(arguments)
    };

    window._hjSettings = {
        hjid: 470270,
        hjsv: 6
    };
    
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
    
    script.onerror = () => {
        console.error('Failed to load Hotjar script');
    };

    document.head.appendChild(script);
};

export default {
    init
};